var $ = jQuery;
if ($(window).width() < 992 ) {
jQuery(document).ready(function($){
  $('.gr-usp .usp-inner,.footer-usp .usp-inner').slick({
    dots: true,
    arrows: false,
		infinite: true,
		slidesToScroll: 1,
		slidesToShow: 3,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToScroll: 1,
					slidesToShow: 1,
                  dots: false,
                  autoplay: true,
				}
			}
		]
  });

  
//   $('.mobile-usp .usp-inner').slick({
//     dots: true,
//     arrows: false,
// 		infinite: true,
// 		slidesToScroll: 1,
// 		slidesToShow: 3,
// 		responsive: [
// 			{
// 				breakpoint: 767,
// 				settings: {
// 					slidesToScroll: 2,
// 					slidesToShow: 2,
//                   dots: true,
//                   autoplay: true,
// 				}
// 			}
// 		]
//   });

});

}